import { p as proxyCustomElement, H, h, c as Host } from './p-0498a6af.js';
import { i as inheritAriaAttributes, n as nanoid } from './p-ea391b91.js';

const stylesCss = ":host{--bic-icon-size:inherit;display:inline-block;font-size:var(--bic-icon-size)}svg{display:block;width:1em;height:1em;fill:currentColor}:host([data-size='2xl']){--bic-icon-size:var(--bi-icon-2xl) !important}:host([data-size='xl']){--bic-icon-size:var(--bi-icon-xl) !important}:host([data-size='large']){--bic-icon-size:var(--bi-icon-large) !important}:host([data-size='medium']){--bic-icon-size:var(--bi-icon-medium) !important}:host([data-size='small']){--bic-icon-size:var(--bi-icon-small) !important}:host([data-color='inherit']){color:inherit}:host([data-color='primary']){color:#01417b}:host([data-color='gray']){color:#1c1b1b}:host([data-color='black']){color:var(--bi-basic-key)}:host([data-color='white']){color:var(--bi-basic-white)}";
const BiIconMailStyle0 = stylesCss;

const BiIconMail$1 = /*@__PURE__*/ proxyCustomElement(class BiIconMail extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.inheritedAttributes = {};
        this.titleText = null;
        /**
         * The color of the icon.
         * @default 'inherit'
         */
        this.color = 'inherit';
    }
    componentWillLoad() {
        this.inheritedAttributes = inheritAriaAttributes(this.el);
        this.titleText = this.el.getAttribute('title');
        if (this.titleText) {
            this.titleId = `title-${nanoid()}`;
        }
    }
    render() {
        return (h(Host, { key: 'a830c76954a4c5a033f5f22de99db818ad217c34', "data-bi-icon": 'true', "data-size": this.size, "data-color": this.color }, h("svg", { key: '6b71ebc76498ad04c92c9c9ee3e9c7f52214ac99', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 25 25', focusable: 'false', role: 'img', width: '1em', height: '1em', fill: 'currentColor', "aria-labelledby": this.titleId, ...this.inheritedAttributes }, this.titleText ? h("title", { id: this.titleId }, this.titleText) : null, h("path", { key: 'f83d3b5f21cbe36d8f5dd3d5c804a0f844448997', "fill-rule": 'evenodd', d: 'M2.877 5.073H22.85v11.734a3.247 3.247 0 0 1-3.246 3.246H6.124a3.247 3.247 0 0 1-3.247-3.246zm1.5 2.564 6.224 6.225a3.248 3.248 0 0 0 4.59 0l.003-.002 6.156-6.217v9.164c0 .963-.783 1.746-1.746 1.746H6.124a1.747 1.747 0 0 1-1.747-1.746zm15.922-1.064H5.434l6.227 6.229c.68.68 1.787.68 2.468 0h.002l6.168-6.23Z', "clip-rule": 'evenodd' }))));
    }
    get el() { return this; }
    static get style() { return BiIconMailStyle0; }
}, [1, "bi-icon-mail", {
        "size": [513],
        "color": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-icon-mail"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-icon-mail":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiIconMail$1);
            }
            break;
    } });
}

const BiIconMail = BiIconMail$1;
const defineCustomElement = defineCustomElement$1;

export { BiIconMail, defineCustomElement };
